export const getEligibilityColor = ({ eligibility }) => {
    return eligibilityColors[eligibility] || eligibilityColors.Pending
}

const eligibilityColors = {
    Eligible: '#718371',
    Ineligible: '#E8744F',
    Pending: '#A4A2A1',
}
